import { render, staticRenderFns } from "./heim-server-card.vue?vue&type=template&id=0107846f&scoped=true&"
import script from "./heim-server-card.vue?vue&type=script&lang=js&"
export * from "./heim-server-card.vue?vue&type=script&lang=js&"
import style0 from "./heim-server-card.vue?vue&type=style&index=0&id=0107846f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0107846f",
  null
  
)

component.options.__file = "heim-server-card.vue"
export default component.exports